(ns teamoesterreich.admin-mode.actions
  (:require
    [teamoesterreich.util.log :as log]
    [teamoesterreich.view-state :as store]
    [teamoesterreich.admin-mode.data.webSelection :as d-webSelection]
    [teamoesterreich.web-path :as web-path]))


(def bottom-bar-back-action-set (fn [_ _]))

(defn register-bottom-bar-back-action-set [bottom-bar-back-action-set_]
  (def bottom-bar-back-action-set bottom-bar-back-action-set_))

(defn set-no-back-page [new-page]
  (.scrollTo js/window 0 0)
  (swap! store/app-state assoc-in
         [:site] new-page
         )
  )

(defn get-help []
  (:help-mode @store/app-state))

(defn set-help [open?]
  (swap! store/app-state assoc-in [:help-mode] open?))

(defn get-page []
  (:site @store/app-state))

(defn set-page [new-page & [back-button-page]]
  (log/debug "action Set page : " new-page back-button-page)
  (.scrollTo js/window 0 0)
  (let [nav (str "" (name new-page))]
    (log/debug "action Set page 1 : " nav)
    (web-path/nav! nav))
  (swap! store/app-state assoc-in
         [:site] new-page
         [:back-to] back-button-page))

(defn set-page-back [or-page]
  (.scrollTo js/window 0 0)
  (swap! store/app-state assoc-in
         [:site] (or (get-in (deref store/app-state) [:back-to]) or-page)
         [:back-to] nil)
  )

(defn set-page-by-path [new-page param1 param2 param3]
  (log/debug "action set-page-by-path : " (str new-page) param1 param2 param3)
  (store/set-path! new-page param1 param2 param3)
  (when (not= (get-page) new-page) (set-page new-page))
  (store/set-path! new-page param1 param2 param3)
  )


(defn toe-list-reload []
  (swap! store/app-state assoc-in [:toe-list :loaded] nil))

(defn unselect-user []
  (swap! store/app-state assoc :selected-tomId nil))


(defn open-user-view [tomId & [tab]]
  (log/debug "action open-user-view : " tomId " tab" tab)
  (swap! store/app-state assoc
         :selected-tomId tomId
         :user-detail {:tab tab})
  (set-page :user-view)
  (store/set-path! :user-view tomId)
  )

(defn open-event-view [event & [tab]]
  (log/debug "action open-event-view : " (:crowdtaskerEvent-uuid event) " tab" tab)
  (swap! store/app-state assoc
         :selected-event event
         :event-detail-loaded false)
  (set-page :event-overview)
  (store/set-path! :event-overview (:crowdtaskerEvent-uuid event))
  )

(defn open-alarm-view [alarm-uuid & [tab]]
  (log/debug "action open-alarm-view : " alarm-uuid " tab" tab)
  (swap! store/app-state assoc
         :selected-alarm-uuid alarm-uuid
         :alarm-detail-loaded false)
  (set-page :event-alarm-overview)
  (store/set-path! :event-alarm-overview alarm-uuid)
  )



(defn open-lr-user-view [tomId]
  (log/debug "action open-lr-user-view : " tomId)
  (swap! store/app-state assoc :selected-tomId tomId)
  (set-page :lebensretter-detail-form)
  (store/set-path! :lebensretter-detail-form tomId)
  )


(defn add-to-selection [users & [cb-fn]]
  (let [selection-uuid (get-in @store/app-state [:selected-elements :list-uuid])]
    (d-webSelection/>add-user selection-uuid users
                              (fn []
                                (swap! store/app-state assoc-in [:selected-elements :loaded] false)
                                (swap! store/app-state assoc-in [:selected-elements :lists-loaded] false)
                                (cb-fn)))))













